import { TLoadable, createUnloaded, createLoading, createLoaded, createLoadErrored } from "../../../../sg-core";
import { IFormAction } from "../actions/formActions";
import IFormDefinition from "../../interfaces/IFormDefinition";
import IFormType from "../../interfaces/IFormType";
import { itemsToMappedIdList, appendUniqueToLodableIdList } from "../../utils/item.helpers";

export const defaultFormState: IFormState = {

    definitions: {},
    currentDefinition: createUnloaded(),

    formTypes: {},
    formTypesByGuid: {},
    formTypeList: createUnloaded(),

};

export interface IFormState {
    definitions: { [key: string]: IFormDefinition }
    currentDefinition: TLoadable<number>;

    formTypes: { [key: string]: IFormType }
    formTypesByGuid: { [key: string]: IFormType }
    formTypeList: TLoadable<number[]>;

}


export default function FormReducer(state = defaultFormState, action: IFormAction) {
    switch (action.type) {


        case "REQUEST_FETCH_FORM_DEFINITION": {
            return {
                ...state,
                currentDefinition: createLoading(),
            };
        }


        case "SUCCESS_FETCH_FORM_DEFINITION": {

            const config = action.payload.formDefinition
            return {
                ...state,
                definitions: { ...state.definitions, [config.id]: config },
                currentDefinition: createLoaded(config.id)
            };
        }


        case "FAILURE_FETCH_FORM_DEFINITION": {
            return {
                ...state,
                currentDefinition: createLoadErrored(action.payload.error)
            };
        }



        case "REQUEST_FETCH_FORM_TYPES": {
            return {
                ...state,
                categoryList: createLoading(),
            };
        }

        case "FAILURE_FETCH_FORM_TYPES": {
            return {
                ...state,
                categoryList: createLoadErrored(action.payload.error),
            };
        }

        case "SUCCESS_FETCH_FORM_TYPES":
        case "APPEND_TO_FORM_TYPE_LIST": {
            const parsed = itemsToMappedIdList(action.payload.formTypes);
            const parsedByGuid = itemsToMappedIdList(action.payload.formTypes, "guid");
            return {
                ...state,
                formTypes: { ...state.formTypes, ...parsed.mapping },
                formTypesByGuid: { ...state.formTypesByGuid, ...parsedByGuid.mapping },
                formTypeList: appendUniqueToLodableIdList(state.formTypeList, parsed.ids),
            };
        }

        default: {
            return state;
        }
    }
}
